import { motion } from "framer-motion";
import { fadeUp, viewport } from "@/components/anim";

const SIGNALS = [
  { ticker: "$BOME", entry: "$180K", peak: "$1.4B", x: "512X", date: "Mar '25", status: "PEAKED" },
  { ticker: "$PEPE2", entry: "$92K", peak: "$38M", x: "420X", date: "Apr '25", status: "PEAKED" },
  { ticker: "$SLERF", entry: "$410K", peak: "$1.2B", x: "310X", date: "May '25", status: "PEAKED" },
  { ticker: "$POPCAT", entry: "$220K", peak: "$51M", x: "233X", date: "May '25", status: "LIVE" },
  { ticker: "$BONK", entry: "$1.1M", peak: "$198M", x: "180X", date: "Jun '25", status: "LIVE" },
  { ticker: "$GIGA", entry: "$340K", peak: "$54M", x: "158X", date: "Jun '25", status: "LIVE" },
];

export const TrackRecord = () => {
  return (
    <section
      id="track"
      data-testid="track-record-section"
      className="relative py-24 sm:py-32 bg-[#0A0D14] border-y border-[#14f19514]"
    >
      <div className="mx-auto max-w-7xl px-5 lg:px-8">
        <motion.div
          variants={fadeUp}
          initial="hidden"
          whileInView="show"
          viewport={viewport}
          className="flex flex-col md:flex-row md:items-end justify-between gap-6 mb-14"
        >
          <div className="max-w-2xl">
            <span className="font-mono text-xs uppercase tracking-[0.3em] text-[#14F195]">
              / Verified Signal History
            </span>
            <h2 className="mt-4 font-display font-extrabold text-3xl sm:text-4xl lg:text-5xl tracking-tight text-white">
              Receipts, not promises.
            </h2>
          </div>
          <p className="font-mono text-sm text-[#64748B] max-w-xs">
            Entry vs peak market cap on recent calls. Every entry is time-stamped in the group.
          </p>
        </motion.div>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-5">
          {SIGNALS.map((s, i) => (
            <motion.div
              key={s.ticker}
              data-testid="signal-card"
              custom={i}
              variants={fadeUp}
              initial="hidden"
              whileInView="show"
              viewport={viewport}
              className="cyber-border glass rounded-2xl p-6 group"
            >
              <div className="flex items-center justify-between mb-5">
                <span className="font-display font-bold text-xl text-white">{s.ticker}</span>
                <span
                  className={`font-mono text-[10px] uppercase tracking-wider px-2 py-1 rounded-full ${
                    s.status === "LIVE"
                      ? "text-[#14F195] bg-[#14f1951a] border border-[#14f19533]"
                      : "text-[#64748B] bg-[#ffffff08] border border-[#ffffff12]"
                  }`}
                >
                  {s.status}
                </span>
              </div>
              <div className="flex items-end justify-between">
                <div>
                  <div className="font-mono text-xs text-[#64748B]">Entry MC</div>
                  <div className="font-mono text-white mt-0.5">{s.entry}</div>
                </div>
                <div className="text-right">
                  <div className="font-mono text-xs text-[#64748B]">Peak MC</div>
                  <div className="font-mono text-white mt-0.5">{s.peak}</div>
                </div>
              </div>
              <div className="mt-5 pt-4 border-t border-[#ffffff0f] flex items-center justify-between">
                <span className="font-mono text-xs text-[#64748B]">{s.date}</span>
                <span className="font-display font-black text-2xl text-[#14F195] text-glow-green group-hover:scale-105 transition-transform">
                  {s.x}
                </span>
              </div>
            </motion.div>
          ))}
        </div>
      </div>
    </section>
  );
};
